import { useState, useEffect } from "react";

export type UseWindowSize = {
  windowSize: UseWindowSizeState;
};

export type UseWindowSizeState = {
  width?: number;
  height?: number;
  isXS?: boolean;
  isSM?: boolean;
  isMD?: boolean;
  isMLG?: boolean;
  isLG?: boolean;
  isXL?: boolean;
};

export const useWindowSize = (): UseWindowSize => {
  const [windowSize, setWindowSize] = useState<UseWindowSizeState>({
    width: undefined,
    height: undefined,
    isXS: undefined,
    isSM: undefined,
    isMD: undefined,
    isMLG: undefined,
    isLG: undefined,
    isXL: undefined,
  });

  const isBrowser = typeof window !== "undefined";

  useEffect(() => {
    const handleResize = () => {
      if (isBrowser) {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
          isXS: window.innerWidth >= 376,
          isSM: window.innerWidth >= 416,
          isMD: window.innerWidth >= 768,
          isMLG: window.innerWidth >= 1024,
          isLG: window.innerWidth >= 1366,
          isXL: window.innerWidth > 1366,
        });
      }
    };

    if (isBrowser) {
      window.addEventListener("resize", handleResize);
      handleResize();
    }

    return () =>
      isBrowser && window.removeEventListener("resize", handleResize);
  }, []);

  return { windowSize };
};
